import React, { Component } from 'react'

class Login extends Component {
render() {
    return (
        <div className="userinput acontent" style={{}}>
            <h4>SEATTLE ADVENTURES:</h4>
            <div style={{}}>
              <input className="userinput-input" type="text" placeholder="Username" onChange={(event) => {this.props.setUsername(event.target.value)}}></input>
              <input className="userinput-input" type="password" placeholder="Password" onChange={(event) => {this.props.setPassword(event.target.value)}}></input>
            </div>
            <div className="userinput-button-container">
              <button className="userinput-button" onClick={this.props.loginUser}>Sign in</button>
              <button className="userinput-button" onClick={this.props.createUser}>Create user</button>
            </div>
            <button className="userinput-guest" onClick={this.props.loginGuest}>Continue as Guest...</button>
          </div>
    );
}}
  
  export default Login;